import React, { createContext, useContext, useReducer } from "react";
import { alertReducer } from "reducers/alertReducer";

//Create context
export const AlertContext = createContext();

//Initial state
const initialState = {
  show: false,
  content: null,
  actionType: ''

};

//Provider
const AlertProvider = ({ children }) => {
  const [alertState, alertDispatch] = useReducer(alertReducer, initialState);


  return (
    <AlertContext.Provider
      value={{
        ...alertState,
        alertDispatch,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

//hook
export const useAlertContext = () => useContext(AlertContext);

export default AlertProvider;
